;"use strict";
(function defGroupsCollection(global) {

  /**
  * Часто используемые селекторы
  */
  var toolBarConatainerSelector = "#toolbar_container";
  var groupSelector = "div.toolbar_group";
  var buttonSelector = "div.toolbar_button";
  var byNameSelectorTemplate = "{0}[name='{1}']";
  //------------------------------------------------------------------------//

  /**
  * Обертка для коллекции кнопок
  * 
  * @class WebAccess.components.wrappers.toolBar.Groups
  * @extends WebAccess.Collecton
  * @since 5.2.0.1600
  */
  var Groups = global.Collection.extend({

    /**
    * Часто-используемые jQuery объекты
    */
    init: function (elements) {
      var me = this;
      me._super(elements);

      me._jToolBarConatainer = $(toolBarConatainerSelector),
      me._jSearchTarget = me._jToolBarConatainer.find(buttonSelector);
    },
    //----------------------------------------------------------------------//

    /**
    * Создает новую группу кнопок панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Groups#create
    * @param {string | object} toolGroupName Имя группы кнопок или объект {name: "", label:"", action:"", icon:""}
    * @param {string} toolGroupNameToAppendAfter Имя существующей группы кнопок на ленте, после которой вставится новая группа
    * @throws ERR_GROUP_NAME_IS_NOT_SPECIFIED_PROPERLY – Неверно указано имя группы.
    * @throws ERR_GROUP_WITH_THE_SAME_NAME_ALREADY_EXIST – Группа с указанным именем уже существует.
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    create: function (toolGroupName, toolGroupNameToAppendAfter) {
      var me = this;
      var jToolBar = me._jToolBarConatainer.children("span").first();

      var name = "";
      var text = L("NEW_GROUP");
      var label = L("NEW_GROUP");
      var icon = "Doc/unknown_32.png";

      if (typeof toolGroupName == "object") {
        //Шабардин П.: Не используется extend потому-что format в качестве шаблонизатора
        name = toolGroupName.name;
        label = toolGroupName.label;
        icon = toolGroupName.icons;
      } else if (typeof toolGroupName == "string") {
        name = toolGroupName;
      } else {
        global.raise("ERR_GROUP_NAME_IS_NOT_SPECIFIED_PROPERLY");
      }

      var jExistingGroup = $(format(byNameSelectorTemplate, groupSelector, name));
      if (jExistingGroup.length > 0) global.raise("ERR_GROUP_WITH_THE_SAME_NAME_ALREADY_EXIST", name);

      if (typeof toolGroupNameToAppendAfter == "string") {
        if (toolGroupNameToAppendAfter === '') {
          jToolBar.prepend(format(ControlTemplate.toolBar.group, name, label, icon));
          var firstChild = jToolBar.children().eq(0);
          // Если это разделитель перемещаем его после группы, т.к. в шаблоне этот разделитель всегда слева.
          if (firstChild.hasClass('toolbar_separator')) {
            jToolBar.find("[name='" + name + "']").after(firstChild);
          }
        } else {
          var jBeforeGroup = jToolBar.find("[name='" + toolGroupNameToAppendAfter + "']");
          if (jBeforeGroup.length) {
            jToolBar.find("[name='" + toolGroupNameToAppendAfter + "']").after(format(ControlTemplate.toolBar.group, name, label, icon));
          } else {
            global.raise("ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST");
          }
        }
      } else {
        jToolBar.append(format(ControlTemplate.toolBar.group, name, label, icon));
      }
      me.addElement(name, new global.components.wrappers.toolBar.ToolBarGroup(format(byNameSelectorTemplate, groupSelector, name)));
      return me[name];
    },
    //----------------------------------------------------------------------//

    /**
    * Проверяет наличие группы кнопок панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Groups#isExist
    * @param {string} toolGroupName Имя группы кнопок
    * @return {boolean} True, если группа кнопок существует, иначе False.
    */
    isExist: function (toolGroupName) {
      var existingGroup = $(format(byNameSelectorTemplate, groupSelector, toolGroupName));
      return existingGroup.length > 0;
    }
    //----------------------------------------------------------------------//
  });

  global.components.wrappers.toolBar.Groups = Groups;

})(window.WebAccess);